import { marked } from "marked";
import React from "react";
import parseHtml from "utils/parserUtil";

import ACButton from "ac-components/ac-button/ACButton";

import "./AnyaTicketCreationConfirmationPopup.less";

interface AnyaTicketCreationConfirmationPopupProps {
  ticketDetails: string;
  actionType?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const AnyaTicketCreationConfirmationPopup: React.FC<
  AnyaTicketCreationConfirmationPopupProps
> = ({ ticketDetails, actionType, onConfirm, onCancel }) => {
  const markedResult = ticketDetails
    ? (marked.parse(ticketDetails) as string)
    : null;
  const parsedContent = markedResult ? parseHtml(markedResult) : null;
  return (
    <div className="anya-ticket-confirmation-container">
      <span>{parsedContent}</span>
      <div className="confirmation-actions">
        <ACButton onClick={onCancel} size="sm" type="outline">
          Cancel
        </ACButton>
        <ACButton type="primary" onClick={onConfirm} size="sm">
          {actionType ?? "Confirm"}
        </ACButton>
      </div>
    </div>
  );
};

export default AnyaTicketCreationConfirmationPopup;
